import { PropertyType } from "@/assets/scripts/PageEditor";

export const IocMalwareHashType = {       
    id: "ioc_malware_hash_type",
    name: "Hash Type",
    type: PropertyType.Enum,
    options: [
        { value: "MD5", text: "MD5" },
        { value: "SHA1", text: "SHA1" },
        { value: "SHA256", text: "SHA256" }
    ]
}
